import {Injectable} from '@angular/core';
import {MapService} from '../map';
import {DealerMapConfig} from './dealer-map.value';
import {DirectionsService} from '../map/directions-map/directions-map.service';
import {MarkerInfoService} from '../map/marker-info/marker-info.service';
import {from, Observable} from 'rxjs';
import {Dealer} from '@ox/typings';

@Injectable()
export class DealerMapService{

  constructor(
    private directionService : DirectionsService,
    private mapService : MapService,
    private markerInfoService: MarkerInfoService)
  {}

  mapInitPromises: any = {};
  dealershipAddress = '';

  // Abstraction for adding a dealer marker to a map
  mapMarker(dealer: any, map: any) {

    const _addMapMarker = () => {
      // Reset the map before adding markers
      map.resetMap();

      const markerInfo = this.DealerMarkerInfo(dealer.name,dealer.address, true);
      markerInfo.markSetPosition(dealer.latitude, dealer.longitude);

      return map.addMapMarker(markerInfo);
    };

    const addDealerMapPromise = new Promise<void>((resolve) => {
      // Don't fail, just don't do anything
      if (!dealer || !dealer.id) return resolve();

      this.mapService.initializeMap().subscribe({
        next: () => _addMapMarker(),
        complete: () => map.resizeMap()
      });
    });
    const addDealerMapObs = from(addDealerMapPromise);
    return addDealerMapObs;
  }

  // Dealer map directions abstraction
  Directions(directionsPanelElement: any, map: any) {
    this.directionService.setDirections(directionsPanelElement, map, DealerMapConfig);
    return this.directionService;
  }

  DealerMarkerInfo(name?: string, address?: string, shouldCenterOnAdd ?: boolean) {
    this.markerInfoService.setMarkerInfo(name, address, shouldCenterOnAdd);
    return this.markerInfoService;
  }

  // Dealer map abstraction
  DealerMap(mapElement: any) {
    this.mapService.setMap(mapElement, DealerMapConfig);
    return this.mapService;
  }

  // this function will just return the current value in the
  // service object for dealership address
  _getDealershipAddress(){
    return this.dealershipAddress;
  }

  // sets the dealership address in the service object to whatever
  // value is passed in from another file
  setDealershipAddress(value: any){
    this.dealershipAddress = value;
  }
}
